import { useEffect, useState } from 'react';
export const useOverflow = () => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [node, setNode] = useState(null);
    useEffect(() => {
        if (node && typeof window !== 'undefined') {
            const offsetHeight = node.offsetHeight;
            const scrollHeight = node.scrollHeight;
            if (scrollHeight - offsetHeight > 2) {
                setIsOverflowing(true);
            }
        }
    }, [node]);
    return [isOverflowing, setNode];
};
//# sourceMappingURL=useOverflow.js.map
// @zapier/design-system@5.18.1 (f78072c92)
